import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * ProtectedRoute — Blocks unauthenticated users and redirects to /login.
 * Shows a loading spinner while auth state is being resolved on refresh.
 */
export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={styles.loader}>
        <div style={styles.spinner} />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}

const styles = {
  loader: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f5f5f5",
  },
  spinner: {
    width: 32,
    height: 32,
    border: "3px solid #e0e0e0",
    borderTopColor: "#3a5a40",
    borderRadius: "50%",
    animation: "spin 0.7s linear infinite",
  },
};
